// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"overview_wrapper__2EfpR","contents":"overview_contents__1ptJk","tabs":"overview_tabs__1xhYx","tab":"overview_tab__VN6t0","active":"overview_active__3U4p8"};